import useMutation from '../hooks/useMutation';
import { type LockerRequest, type LockerResponse } from '../model/locker';

export function useOpenLockerMutation() {
  return useMutation<LockerRequest, LockerResponse>('/lockers', 'put');
}
